/* global $, Hammer */
// ===========================================================================
// GESTIONE DELL'IMMAGINE DETTAGLIO IN DETTAGLIO ARTICOLO
// ===========================================================================
function slideIndicator(indicator, index) {
  for (let i = 0; i < indicator.length; i += 1) {
    if (i === index) {
      indicator[i].classList.add('selected');
    } else {
      indicator[i].classList.remove('selected');
    }
  }
}

function slideDetail(index, amount, $target, $indicator) {
  const margin = amount * index;
  // $target.css('margin-left', '-' + margin + 'px');
  $target.css('transform', 'translateX(-' + margin + 'px)');
  slideIndicator($indicator, index);
}


$(document).ready(function () {

  // se mi trovo nel dettaglio articolo
  if ($('#dettaglio-articolo').length) {


    // new image scroll
    const $imgColumn = $('#image-column');
    const $imgColumnRow = $('#image-column > .row');
    const $imgDetail = $('.image-detail-content');
    const $wrapperDetail = $('#wrapper-detail');
    const $indicator = $('.thumb-details');

    const $nextDetail = $('#next-detail-img');
    const $prevDetail = $('#prev-detail-img');

    let imgWidth = 0;
    const swipeImg = new Hammer($imgColumn[0]);


    // mobile
    if ($(window).width() < 768) {

      // setto la larghezza del container in base allo spazio disponibile visualizzato
      imgWidth = $imgColumn.width();

      // per evitare immagini troppo grandi se lo spazio nel container
      // è superiore a 300px setto l'immagine ad un valore fisso
      if (imgWidth < 500) {
        $imgDetail.width(imgWidth);
      } else {
        $imgDetail.width(imgWidth);
        $imgDetail.children('img').width(500);
        $imgDetail.children('video').width(500);
      }

      // desktop
    } else {

      // Setto la larghezza del container e la dimensione delle immagini (desktop)
      imgWidth = $imgColumnRow.width();

      $imgDetail.width(imgWidth);
      $imgDetail.children('img').width(500);
      $imgDetail.children('video').width(500);
    }

    // Calcolo la grandezza del wrapper che ospiterà i contenitori e le immagini
    // moltiplicando la grandezza dei contenitori per il loro numero
    // per far funzionare questo metodo è necessario un fix css per gli
    // elementi inline-block impostandoli con margin-right: -4px;
    const wrapperWidth = imgWidth * $imgDetail.length;
    $wrapperDetail.width(wrapperWidth);


    let imgIndex = parseInt($imgDetail.attr('data-index-zoom'), 10);
    const maxIndex = ($imgDetail.length) - 1;


    // Muovo all'immagine successiva
    $nextDetail.on('click', function () {
      if (imgIndex < maxIndex) {
        imgIndex += 1;
      } else {
        imgIndex = 0;
      }
      slideDetail(imgIndex, imgWidth, $wrapperDetail, $indicator);
    });

    // Muovo all'immagine precedente
    $prevDetail.on('click', function () {
      if (imgIndex > 0) {
        imgIndex -= 1;
      } else {
        imgIndex = maxIndex;
      }
      slideDetail(imgIndex, imgWidth, $wrapperDetail, $indicator);
    });

    // Muovo all'immagine successiva con swipe gesture
    swipeImg.on('swipeleft', function () {
      if (imgIndex < maxIndex) {
        imgIndex += 1;
        console.log(imgIndex);
      } else {
        imgIndex = 0;
      }
      slideDetail(imgIndex, imgWidth, $wrapperDetail, $indicator);
    });

    // Muovo all'immagine precedente con swipe gesture
    swipeImg.on('swiperight', function () {
      if (imgIndex > 0) {
        imgIndex -= 1;
      } else {
        imgIndex = maxIndex;
      }
      slideDetail(imgIndex, imgWidth, $wrapperDetail, $indicator);
    });

    // Muovo l'immagine in base al click sulla thumb
    $indicator.on('click', function () {
      imgIndex = $(this).attr('data-image-index');
      slideDetail(imgIndex, imgWidth, $wrapperDetail, $indicator);
    });
  }
});
